import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { CustomSVG } from 'components';

import { LINE_CHART_LOADER_HEIGHT } from '../constants';
import useStyles from '../analyticsStyles';

const LineChartLoader: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const fontSize = theme.typography.pxToRem(LINE_CHART_LOADER_HEIGHT / 3);

  return (
    <div style={{ height: LINE_CHART_LOADER_HEIGHT }} className={classes.loadingWrapper}>
      <Typography className={classes.placeholderText} variant="h5">
        {t('analytics:coming_soon_graph')}
      </Typography>
      <CustomSVG style={{ fontSize }} className={classes.placeholder} name="chartLine" />
    </div>
  );
};

export default LineChartLoader;
